import {connect} from "react-redux"
import State from "../../models/State"

export const mapStateToProps = (state: State) => {
    const {
        template,
        search: {breadcrumbs},
        request: {url},
    } = state

    return {
        breadcrumbs,
        url,
        templating: template,
    }
}

export default connect(mapStateToProps)
